import { lazy } from "react";
import { Suspense } from "react";
// **************************************'Icons import ***********************************************
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import MapIcon from "@mui/icons-material/Map";
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import TempleHinduIcon from '@mui/icons-material/TempleHindu';
import CategoryIcon from "@mui/icons-material/Category";
import InventoryIcon from "@mui/icons-material/Inventory";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ContactsIcon from '@mui/icons-material/Contacts';
import Diversity1Icon from '@mui/icons-material/Diversity1';

// ************************************** Pages import ***********************************************
// const Dashboard= lazy(import("pages/dashboard/Dashboard"));
import Dashboard from "pages/dashboard/Dashboard";

// ***************************************** Donation Management ************************************************
import DonationManagement from "pages/DonationManagement/DonationManagement";
import AddNewDonation from "pages/DonationManagement/AddNewDonation";

// ************************************* User Management ************************************************
import ManageUser from "pages/UserManagement/ManageUsers";
import AddUser from "pages/UserManagement/ManageUser/sub/AddUser";
import EditUser from "pages/UserManagement/ManageUser/sub/EditUser";

// ********************************************* Category Management ******************************************
import CategoryManagementList from "pages/CategoryManagement/CategoryManagementList";

// ********************************************* Inventory Management ******************************************
import InventoryManagementList from "pages/InventoryManagement/ProductManagementList";
import InventoryAddProduct from "pages/InventoryManagement/sub/AddProduct";
import InventoryUpdateProduct from "pages/InventoryManagement/sub/UpdateProduct";
import ItemSellsList from "pages/ItemSells/ItemSellsList";
import AddCustomer from "pages/ItemSells/sub/AddCustomer";
import UpdateCustomer from "pages/ItemSells/sub/UpdateCustomer";
import ContactUs from "pages/ContactUs/ContactUs";
import DharmikSankalpanaList from "pages/DharmikSankalpana/DharmikSankalpanaList";
import AddDharmikSankalpana from "pages/DharmikSankalpana/sub/AddDharmikSankalpana";
import UpdateDharmikSankalpana from "pages/DharmikSankalpana/sub/UpdateDharmikSankalpana";
import VastuDengiList from "pages/VastuDengi/VastuDengiList";
import AddDengi from "pages/VastuDengi/sub/AddDengi";
import UpdateDengi from "pages/VastuDengi/sub/UpdateDengi";
import BhaktaParivar from "pages/BhaktaParivar/BhaktaParivar";
import AddBhaktaParivar from "pages/BhaktaParivar/sub/AddBhaktaParivar";
import UpdateBhaktaParivar from "pages/BhaktaParivar/sub/UpdateBhaktaParivar";

const ManageRoles = lazy(
  () => import("pages/UserManagement/ManageRoles/ManageRoles")
);

const ViewUser = lazy(
  () => import("pages/UserManagement/ManageUser/sub/ViewUser")
);
const AddRole = lazy(
  () => import("pages/UserManagement/ManageRoles/sub/AddRole")
);
const EditRole = lazy(
  () => import("pages/UserManagement/ManageRoles/sub/EditRole")
);

// ********************************************* Item Sells Management ******************************************

// ******************************************* Sidebar tabs ******************************************
export const sidebar = (roles = []) => {
  const sidebarData = [
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Dashboard",
      icon: <DashboardIcon fontSize="small" />,
      path: "/dashboard",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "User Management",
      icon: <PersonIcon fontSize="small" />,
      path: "/user-management/manage-user",
      isChild: [
        {
          id: 100000,
          enabled: roles.includes(100000),
          name: "Manage Users",
          path: "/user-management/manage-user",
        },
        // {
        //   id: 100000,
        //   enabled: roles.includes(100000),
        //   name: "Manage Roles",
        //   path: "/user-management/manage-role",
        // },
      ],
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "धार्मिक संकल्प",
      icon: <TempleHinduIcon fontSize="small" />,
      path: "/dharmik-sankalpana",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Donation Management",
      icon: <CardGiftcardIcon fontSize="small" />,
      path: "/donation-management",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "वस्तू देणगी",
      icon: <VolunteerActivismIcon fontSize="small" />,
      path: "/vastu-dengi",
      isChild: null,
    },

    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Category Management",
      icon: <CategoryIcon fontSize="small" />,
      path: "/category-management",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Inventory Management",
      icon: <InventoryIcon fontSize="small" />,
      path: "/inventory-management",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Item's Sales Management",
      icon: <MonetizationOnIcon fontSize="small" />,
      path: "/items-sells",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "Contact Management",
      icon: <ContactsIcon fontSize="small" />,
      path: "/contact",
      isChild: null,
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      name: "भक्त परिवार",
      icon: <Diversity1Icon fontSize="small" />,
      path: "/bhakta-parivar",
      isChild: null,
    },
  ].filter((side) => side.enabled);
  // ];

  return sidebarData;
};

export const routes = (roles = []) => {
  const routesData = [
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <Dashboard />,
      path: "/dashboard",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <ManageUser />
        </Suspense>
      ),
      path: "/user-management/manage-user",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <AddUser />
        </Suspense>
      ),
      path: "/user-management/manage-user/add-user",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <EditUser />
        </Suspense>
      ),
      path: "/user-management/manage-user/edit-user/:id",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <ViewUser />
        </Suspense>
      ),
      path: "/user-management/manage-user/view-user/:id",
    },

    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <AddRole />,
      path: "/user-management/manage-role/add-role",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <EditRole />,
      path: "/user-management/manage-role/edit-role/:id",
    },

    // *************************************  Donation Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <DharmikSankalpanaList />,
      path: "/dharmik-sankalpana",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <AddDharmikSankalpana />,
      path: "/dharmik-sankalpana/add-sankalpana",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <UpdateDharmikSankalpana />,
      path: "/dharmik-sankalpana/update-sankalpana/:id",
    },
    // *************************************  Donation Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <DonationManagement />,
      path: "/donation-management",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <AddNewDonation />,
      path: "/donation-management/add-new-donation",
    },

    // **************************************** Category Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <CategoryManagementList />,
      path: "/category-management",
    },

    // **************************************** Inventory Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <InventoryManagementList />,
      path: "/inventory-management",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <InventoryAddProduct />,
      path: "/inventory-management/add-product",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <InventoryUpdateProduct />,
      path: "/inventory-management/update-product/:id",
    },
    
    // **************************************** Inventory Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <ItemSellsList />,
      path: "/items-sells",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <AddCustomer />,
      path: "/items-sells/add-customer",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <UpdateCustomer />,
      path: "/items-sells/update-customer/:id",
    },
    
    // **************************************** Inventory Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <ContactUs />,
      path: "/contact",
    },
    // **************************************** Inventory Management ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <BhaktaParivar />,
      path: "/bhakta-parivar",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <AddBhaktaParivar />,
      path: "/bhakta-parivar/add-bhakta",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <UpdateBhaktaParivar />,
      path: "/bhakta-parivar/update-bhakta/:id",
    },

    // **************************************** Vastu Dengi ****************************************
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <VastuDengiList />,
      path: "/vastu-dengi",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <AddDengi />,
      path: "/vastu-dengi/add-dengi",
    },
    {
      id: 100000,
      enabled: roles.includes(100000),
      element: <UpdateDengi />,
      path: "/vastu-dengi/update-dengi/:id",
    },
  ].filter((route) => route.enabled);
  // ];
  return routesData;
};
